"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreValues = void 0;
const react_1 = __importDefault(require("react"));
exports.MoreValues = (props) => {
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "9", height: "8", fill: "none", viewBox: "0 0 9 8" }, props),
        react_1.default.createElement("path", { fill: "#30C1FF", d: "M1.129.813v6.359h.797v.813H0V0h1.926v.813H1.13zM2.574 3.504h1.384v-1.36h1.084v1.36h1.384v.976H5.042v1.36H3.958V4.48H2.574v-.976zM7.074.813V0H9v8H7.074v-.813h.797V.828h-.797V.813z" })));
};
